import getUrl from "Libs/getUrl";
import { branch } from "Reducers/environment/actions/branch";
import {
  getOrganization,
  updateOrganization,
  createOrganization
} from "Reducers/organization/organization";

import type { NavigateFunction } from "react-router-dom";
// Storage for navigate function from React Router
let routerNavigate: NavigateFunction | undefined = undefined;

// Register the navigate function
export const registerNavigate = (navigate: NavigateFunction) => {
  routerNavigate = navigate;
};

// Navigation middleware
// store isn't being used yet but keep it anyway.
// eslint-disable-next-line
export const navigationMiddleware = store => next => action => {
  // First, let the action go through the regular flow
  const result = next(action);

  switch (action.type) {
    case branch.fulfilled.type: {
      const { organizationId, projectId } = action.meta.arg ?? {
        organizationId: "",
        projectId: ""
      };

      if (action?.payload?.parameters?.environment) {
        const environmentOverviewUrl = getUrl({
          key: "organization.project.environment",
          props: {
            organizationId,
            projectId,
            environmentId: action.payload.parameters.environment
          }
        });
        routerNavigate?.(environmentOverviewUrl);
      }
      break;
    }
    case updateOrganization.fulfilled.type:
    case getOrganization.rejected.type:
    case getOrganization.fulfilled.type: {
      const redirectTo = action.payload?.redirectTo;

      if (redirectTo) {
        routerNavigate?.(redirectTo, { replace: true });
      }
      break;
    }
    case createOrganization.fulfilled.type: {
      const { payload, meta } = action ?? {
        payload: undefined,
        meta: undefined
      };

      const redirectTo = meta.arg?.redirectTo;
      const newOrganizationId = payload?.id;
      const newOrganizationDescriptionId = payload?.name;

      if (redirectTo && newOrganizationId && newOrganizationDescriptionId) {
        const newPath = getUrl({
          key: "organization",
          props: { organizationId: newOrganizationDescriptionId }
        });

        routerNavigate?.(newPath, { replace: true });
      }
      break;
    }
  }

  return result;
};
